import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-title-header',
  standalone: true,
  imports: [
    TranslateModule,
    CommonModule
  ],
  templateUrl: './title-header.component.html',
  styleUrl: './title-header.component.scss'
})
export class TitleHeaderComponent {
  @Input() title!: string;
  @Input() description!: string;
  @Input() iconClass!: string;
  @Input() iconLink!: string;
  @Input() viewMode!: boolean;
  copiedMessage!: string;

  constructor(private router: Router) {}

  goTo() {
    if(this.iconLink) {
      this.router.navigateByUrl(this.iconLink);
    }
  }

  copyToClipboard() {
    navigator.clipboard.writeText(this.title).then(() => {
      this.copiedMessage = 'messages.copied_to_clipboard';
      setTimeout(() => {
        this.copiedMessage = '';
      }, 2000);
    })
  }
}
